// 1000 becomes 1,000
export function formatLargeNumber(num: number) {
  return new Intl.NumberFormat('en-US').format(num);
}
